import { yyyy, zzzz } from "../store.svelte";
import getlivewires from "./getlivewires.svelte"

const uri: string = yyyy.uri.api;


export default async (shortcode: string) => {
	console.log('bookmarking...')
	getlivewires()
	if (!yyyy.sesh.logtoken) {
		console.log('k')
		return false;
	}
	console.log('1')
	let _hdrs = {
		"Content-Type": "application/json",
		Authorization: "Bearer " + yyyy.sesh.logtoken.token,
	};
	let fetchopts = { method: "GET", headers: _hdrs };
	const response = await fetch(`${uri}/bookmarks?shortcode=eq.${shortcode}`, fetchopts);
	if (response.ok) {
		let data = await response.json();
		//return data;
		console.log(data);
		if (data.length === 1) {
			let toast_message = {
				message: `Taking you to ${data[0].bookmark}`,
				type: "is-info",
				dismissible: false,
				duration: 6500,
				position: "top-center",
			};
			zzzz.emit("toast", toast_message);


			let activeLivewire = yyyy.livewires.find(lw => lw.wireident === data[0].wireident);
			console.log('::', activeLivewire);

			history.pushState({uri: '/livewires'}, "lvwr.io", "/livewires")
			yyyy.sesh.activeLivewire = {
				wireident: activeLivewire.wireident,
				livewire: activeLivewire.livewire,
				extent: activeLivewire.g,
				bookmark: data[0].g
			};
			zzzz.emit("map-active");
		} else {

			let toast_message = {
				message: `Bookmark with shortcode ${shortcode} not found.`,
				type: "is-danger",
				dismissible: false,
				duration: 6500,
				position: "top-center",
			};

			history.pushState({uri: '/'}, "lvwr.io", "/")
			zzzz.emit("toast", toast_message);
			zzzz.emit("goto", "/livewires")

		}



	} else {
		alert("There was an error");
	}
};


